import { Container, makeStyles, Typography } from "@material-ui/core"
import React from "react"
import useSEO from "../components/Shared/useSEO"

const useStyles = makeStyles(theme => ({
  heading: {
    color: theme.palette.grey[600],
    fontWeight: 700,
    textTransform: "uppercase",
    fontStyle: "italic",
    letterSpacing: -5,
    // fontSize: 200,
    // [theme.breakpoints.down("md")]: {
    //   fontSize: 150,
    // },
    // [theme.breakpoints.down("xs")]: {
    //   fontSize: 90,
    // },
  },
}))
export default function Schedule() {
  useSEO({ title: "Spielplan" })
  const classes = useStyles()
  return (
    <Container maxWidth="md">
      <Typography variant="h1" className={classes.heading}>
        Spielplan
      </Typography>
      <Typography variant="h4">Aktuell keine Spiele wegen Corona...</Typography>
    </Container>
  )
}
